import { FC } from 'react';
import operationTypes from 'constants/operationTypes';

import CapitalVariationOperationTableFooter from '../components/CapitalVariationOperation/CapitalVariationOperationTableFooter';

export const operationTableFooterMap: Record<string, FC> = {
  [operationTypes.CONSTITUTION]: CapitalVariationOperationTableFooter,
  [operationTypes.CAPITAL_INCREASE]: CapitalVariationOperationTableFooter,
  [operationTypes.CAPITAL_DECREASE]: CapitalVariationOperationTableFooter,
};
